<div class="flex header">
    <p>{{message.messageType}}</p>
</div>

<div class='message-description'>
    <p style="white-space: pre-wrap">{{message.textMessage}}</p>
</div>